// extracted by mini-css-extract-plugin
export default {"WsWrap":"Ws_WsWrap__JON+V","Alert":"Ws_Alert__+szBH","CloseBtn":"Ws_CloseBtn__fwGSU"};